var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0 ma-0", attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "", color: "toolbar" } },
        [
          _c("v-toolbar-title", { staticClass: "ml-2 title" }, [
            _vm._v(" Period Closing "),
          ]),
          _c("v-divider", {
            staticClass: "mx-4",
            attrs: { vertical: "", inset: "" },
          }),
          _c(
            "v-row",
            { staticClass: "align-center d-flex", attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { cols: "2" } },
                [
                  _c("v-autocomplete", {
                    staticStyle: { height: "40px" },
                    attrs: {
                      items: _vm.billingYears,
                      "item-text": "constant",
                      "item-value": "id",
                      "prepend-inner-icon": "mdi-filter-outline",
                      dense: "",
                      solo: "",
                      flat: "",
                      outlined: "",
                      placeholder: "Year",
                      "menu-props": { maxHeight: 260, rounded: "" },
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchParams.billing_year_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "billing_year_id", $$v)
                      },
                      expression: "searchParams.billing_year_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { cols: "2" } },
                [
                  _c("v-autocomplete", {
                    staticStyle: { height: "40px" },
                    attrs: {
                      items: _vm.billingPeriods,
                      "item-text": "constant",
                      "item-value": "id",
                      "prepend-inner-icon": "mdi-filter-outline",
                      dense: "",
                      solo: "",
                      flat: "",
                      outlined: "",
                      placeholder: "Period",
                      "menu-props": { maxHeight: 260, rounded: "" },
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchParams.billing_period_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "billing_period_id", $$v)
                      },
                      expression: "searchParams.billing_period_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { cols: "2" } },
                [
                  _c("v-autocomplete", {
                    staticStyle: { height: "40px" },
                    attrs: {
                      items: _vm.recapComponents,
                      "item-text": "name",
                      "item-value": "id",
                      "prepend-inner-icon": "mdi-filter-outline",
                      dense: "",
                      solo: "",
                      flat: "",
                      outlined: "",
                      placeholder: "Component",
                      "menu-props": { maxHeight: 260, rounded: "" },
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchParams.recap_component_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "recap_component_id", $$v)
                      },
                      expression: "searchParams.recap_component_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { cols: "2" } },
                [
                  _c("v-text-field", {
                    staticStyle: { height: "40px" },
                    attrs: {
                      "prepend-inner-icon": "mdi-filter-outline",
                      dense: "",
                      solo: "",
                      flat: "",
                      outlined: "",
                      placeholder: "Store #",
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchParams.store_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "store_number", $$v)
                      },
                      expression: "searchParams.store_number",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticStyle: {
                    display: "grid",
                    "justify-content": "flex-end",
                    "grid-auto-flow": "column",
                    "grid-column-gap": "12px",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: _vm.process_loading },
                      on: {
                        click: function ($event) {
                          ;(_vm.component = "PeriodCloseModal"),
                            (_vm.modal = true)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "loader",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { class: _vm.getLoader(_vm.process.status) },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v(
                                      _vm._s(_vm.getLoaderIcon(_vm.process))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-calendar-check"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.process
                              ? _vm.getProcessButtonText(_vm.process)
                              : "Close Billing Period"
                          ) +
                          " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
      _c("v-data-table", {
        style: { position: "relative", "z-index": "1" },
        attrs: {
          dense: "",
          items: _vm.autoRecapAdditions,
          "items-per-page": _vm.pageSize,
          headers: _vm.headers,
          height: _vm.tableSize,
          loading: _vm.loading,
          "item-key": "id",
          "fixed-header": "",
          "hide-default-footer": "",
        },
        on: {
          "update:itemsPerPage": function ($event) {
            _vm.pageSize = $event
          },
          "update:items-per-page": function ($event) {
            _vm.pageSize = $event
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item.amount",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c("div", [
                    _vm._v(
                      _vm._s("$" + _vm.formatCurrencyDisplay(item.amount))
                    ),
                  ]),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c("v-divider"),
      _c(
        "v-toolbar",
        { attrs: { flat: "", color: "#fafafa" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "end" } },
            [
              _c(
                "v-col",
                { staticStyle: { "max-width": "150px" }, attrs: { cols: "2" } },
                [
                  _c("v-select", {
                    staticClass: "mt-8",
                    attrs: {
                      dense: "",
                      items: _vm.pageSizes,
                      label: "Items Per Page",
                      select: "",
                      "menu-props": {
                        top: true,
                        offsetY: true,
                        maxHeight: 500,
                      },
                    },
                    model: {
                      value: _vm.pageSize,
                      callback: function ($$v) {
                        _vm.pageSize = $$v
                      },
                      expression: "pageSize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "mx-2",
                  attrs: { icon: "", large: "", disabled: _vm.disablePrevious },
                  on: {
                    click: function ($event) {
                      return _vm.previous()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                1
              ),
              _c("small", [_vm._v("Page " + _vm._s(_vm.page))]),
              _c(
                "v-btn",
                {
                  staticClass: "mx-2",
                  attrs: { icon: "", large: "", disabled: _vm.disableNext },
                  on: {
                    click: function ($event) {
                      return _vm.next()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.modal
        ? _c(_vm.component, {
            tag: "Component",
            attrs: { value: _vm.modal },
            on: {
              "update:value": function ($event) {
                _vm.modal = $event
              },
              close: _vm.closeModal,
              closeProcessModal: _vm.closeProcessModal,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }